export const AnyBuildId: number = 0;
